
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, companyModule } from '@/store/modules/store-accessor'

  @Component
  export default class ToggleCompanyPreferencesModal extends Vue {
    @Prop()
    payload!: any;
    isRestoringType = false;
    preferencesFlag = false;

    preference = this.payload.key;

    async hideModal (reload = false) {
      if (reload) {
        await companyModule.getCompanyInfo(true);
      }
      commonModule.hideModal();
    }

    beforeMount() {
      this.preferencesFlag = !((companyModule.company?.preferences as any)[this.preference]);
    }

    updatePreferences() {
      this.hideModal()
    }

     async toggleInstallationDescription () {
        this.isRestoringType = true;
         await companyModule.editCompany({id: companyModule.company.id, [this.preference]: this.preferencesFlag});
        await this.hideModal(true)
    }
  };
